// Route definitions with full lazy loading for React Router v7
import ErrorPage from '@components/ErrorPage';

const AppRoutes = [
  {
    id: 'auth-callback',
    path: '/auth/callback',
    lazy: async () => {
      const { default: AuthCallback } = await import('@/auth/AuthCallback');
      return {
        Component: AuthCallback,
      };
    },
  },
  {
    id: 'auth-silent-redirect',
    path: '/auth/silent-redirect',
    lazy: async () => {
      const { default: SilentCallback } = await import('@/auth/SilentCallback');
      return {
        Component: SilentCallback,
      };
    },
  },
  {
    id: 'auth-logout',
    path: '/auth/logout',
    lazy: async () => {
      const { default: LogoutCallback } = await import('@/auth/LogoutCallback');
      return {
        Component: LogoutCallback,
      };
    },
  },
  {
    id: 'root',
    path: '/',
    lazy: async () => {
      const { default: Home } = await import('@components/Home');
      return {
        Component: Home,
      };
    },
    children: [
      {
        id: 'orders-index',
        index: true,
        lazy: async () => {
          const { default: Orders } = await import('@components/Orders');
          return {
            Component: Orders,
            loader: async () => {
              // Orders data is now handled by OrdersContext
              await new Promise(resolve => setTimeout(resolve, 100));
              return null;
            },
          };
        },
      },
      {
        id: 'orders',
        path: 'orders',
        lazy: async () => {
          const { default: Orders } = await import('@components/Orders');
          return {
            Component: Orders,
            loader: async () => {
              // Orders data is now handled by OrdersContext
              await new Promise(resolve => setTimeout(resolve, 100));
              return null;
            },
          };
        },
      },
      {
        id: 'products',
        path: 'products',
        lazy: async () => {
          const { default: ProductsRouteGuard } = await import('@routes/ProductsRouteGuard');
          return {
            Component: ProductsRouteGuard,
          };
        },
      },
      {
        id: 'channels',
        path: 'channels',
        lazy: async () => {
          const { default: ChannelsRouteGuard } = await import('@routes/ChannelsRouteGuard');
          return {
            Component: ChannelsRouteGuard,
            loader: async () => {
              // Loading channels data...
              await new Promise(resolve => setTimeout(resolve, 100));
              return { channels: [] }; // Placeholder data
            },
          };
        },
      },
      {
        id: 'audit-logs',
        path: 'audit-logs',
        lazy: async () => {
          const { default: AuditLogs } = await import('@components/AuditLogs');
          return {
            Component: AuditLogs,
            loader: async () => {
              await new Promise(resolve => setTimeout(resolve, 100));
              return null;
            },
          };
        },
      },
      {
        id: 'navigation',
        path: 'navigation',
        lazy: async () => {
          const { default: Navigation } =
            await import('@components/Navigation');
          return {
            Component: Navigation,
            loader: async () => {
              await new Promise(resolve => setTimeout(resolve, 100));
              return null;
            },
          };
        },
      },
    ],
    errorElement: <ErrorPage />,
  },
  {
    id: 'dev-theming',
    path: '/dev/theming',
    lazy: async () => {
      const { default: ThemingDemo } = await import('@demos/ThemingDemo');
      return {
        Component: ThemingDemo,
      };
    },
  },
];

export default AppRoutes;
